import { SYSTEM_ERROR } from "../config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllPaymentFatoraTable = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(
          `${BaseUrl}/api/getAllPaymentFatora`,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          resolve(res.data);
          
        })

        .catch((err) => {
          reject("Error in getAllTrips axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
